import { toMiliseconds } from "@/utils/promise-util"

const tefRequestDataEnum = {
  DOCUMENT: 'Document',
  JURIDICAL_DOCUMENT: 'JuridicalDocument',
  PHONE_WITH_AREA_CODE: 'PhoneWithAreaCode',
}

const getInitialState = () => ({
  customerDocument: {
    isWaiting: false,
    errorMessage: '',
  }
})

let messageTimeout

export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    SET_CUSTOMER_DOCUMENT_WAITING(state, isRequesting) {
      state.customerDocument.isWaiting = isRequesting
    },
    SET_CUSTOMER_DOCUMENT_ERROR_MESSAGE(state, { message }) {
      state.customerDocument.errorMessage = message
    },

    CLEAN_STATE(state) {
      const initial = getInitialState()
      Object.keys(initial).forEach(key => {
        state[key] = initial[key]
      })
    },
  },
  getters: {
    isTefCustomerDocumentWaiting(state) {
      return state.customerDocument.isWaiting
    },
    getTefCustomerDocumentMessageError(state) {
      return state.customerDocument.errorMessage
    },
  },

  actions: {
    async tefRequestCustomerDocument({ dispatch, commit, getters, rootState, rootGetters }) {
      if (getters.isTefCustomerDocumentWaiting) {
        return
      }

      console.log('[tef request document] start request')

      commit('SET_CUSTOMER_DOCUMENT_WAITING', true)
      commit('SET_CUSTOMER_DOCUMENT_ERROR_MESSAGE', { message: '' })

      const configPayload = rootGetters['pages/pdv/payBoxConfiguration/tefAgentConfigPayload']
      window.electronAPI.tef
        .requestData(configPayload, { dataType: tefRequestDataEnum.DOCUMENT })
        .then(async result => {
          console.debug('[tef request document] start')
          await dispatch('pages/pdv/payBox/clearPayBoxRewardData', null, { root: true })

          const errorResult = await dispatch('pages/pdv/payBox/searchAndSetClient', { document: result.data, isDocumentFromTef: true }, { root: true })

          if (errorResult?.message) {
            clearTimeout(messageTimeout)

            commit('SET_CUSTOMER_DOCUMENT_ERROR_MESSAGE', { message: errorResult?.message })

            messageTimeout = setTimeout(() => {
              commit('SET_CUSTOMER_DOCUMENT_ERROR_MESSAGE', { message: '' })
            }, toMiliseconds({ sec: 20 }))
            console.debug('[tef request document] end')
            return
          }

          const customerId = rootState.pages?.pdv?.payBox?.clientForm?.id
          if (customerId) {
            await dispatch('reward/getCustomerRewardBalance', customerId, { root: true })
          }
          console.debug('[tef request document] end')
        })
        .catch(err => console.error('[tef request document]', err))
        .finally(() => {
          commit('SET_CUSTOMER_DOCUMENT_WAITING', false)
          console.log('[tef request document] finish request')
        })
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    }
  },
}
